import * as PropTypes from 'prop-types'
import { withViewport } from '/react/utils/withViewport'

import whiteSpaceStyles from './WhiteSpace.css'

@withViewport()
export class WhiteSpace extends React.PureComponent {
  static propTypes = {
    height: PropTypes.object.isRequired,
  }

  state = {
    isMounted: false
  }

  componentDidMount () {
    this.setState({ isMounted: true })
  }

  render () {
    const { isMounted } = this.state

    if (!isMounted) return null

    const { height } = this.props
    const currentHeight = this.props.viewportIsLaptopOrBigger ?
      (
        this.props.viewportIsDesktopOrBigger ? height.large : height.medium
      ) : height.default

    return (
      <div className={whiteSpaceStyles.container} style={{ height: currentHeight }} />
    )
  }
}
